// Loads Razorpay Checkout script once and returns when ready
let razorpayLoadPromise = null;

export function loadRazorpay() {
    if (window.Razorpay) return Promise.resolve(true);
    if (razorpayLoadPromise) return razorpayLoadPromise;
    razorpayLoadPromise = new Promise((resolve) => {
        const s = document.createElement("script");
        s.src = "https://checkout.razorpay.com/v1/checkout.js";
        s.async = true;
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.body.appendChild(s);
    });
    return razorpayLoadPromise;
}
